module.exports = __webpack_public_path__ + "img/empty-icon.e534291c.png";